document.addEventListener("DOMContentLoaded", () => {
  "use strict";

  const triggers = document.querySelectorAll('.js-scroll');

  for (const trigger of triggers) {
    trigger.addEventListener("click", (e) => {
      e.preventDefault();

      const targetId = trigger.getAttribute("href");
      let scrollPos = 0; //スクロール位置

      if (targetId !== "#") {
        const target = document.querySelector(targetId);
        if (!target) return;
        const targetY = target.getBoundingClientRect().top; //スクロール先要素の位置
        const currentY = window.scrollY; //スクロール量
        //const headerHeight = document.querySelector("header").offsetHeight; //固定ヘッダーの高さ

        //scrollPos = targetY + currentY - headerHeight;
        scrollPos = targetY + currentY;
      }

      window.scrollTo({
        top: scrollPos,
        behavior: "smooth",
      });
    });
  }
});

document.addEventListener("DOMContentLoaded", () => {
  "use strict";

  const items = document.querySelectorAll('.c-list-notes > li');

  for (const item of items) {
    const firstNode = item.firstChild;
    if (!firstNode || firstNode.nodeType !== Node.TEXT_NODE) continue;

    const match = firstNode.textContent.match(/^(※|\*|・)/);
    if (!match) continue;

    const symbol = match[1];
    const restText = firstNode.textContent.slice(symbol.length);

    item.removeChild(firstNode);

    const symbolSpan = document.createElement("span");
    symbolSpan.textContent = symbol;

    const textSpan = document.createElement("span");
    if (restText) {
      textSpan.appendChild(document.createTextNode(restText));
    }
    while (item.firstChild) {
      textSpan.appendChild(item.firstChild);
    }

    item.appendChild(symbolSpan);
    item.appendChild(textSpan);

    item.closest('.c-list-notes').classList.add("is-split");
  }
});

document.addEventListener("DOMContentLoaded", () => {
  "use strict";

  const NAV_CONTAINER_SELECTOR = '.jdgm-carousel-review-list__nav-container';
  const PREV_SELECTOR = '.jdgm-carousel-review-list__nav--prev';
  const NEXT_SELECTOR = '.jdgm-carousel-review-list__nav--next';

  const ARIA_LABELS = document.documentElement.lang === 'ja'
    ? { prev: '前へ', next: '次へ' }
    : { prev: 'Previous', next: 'Next' };

  const PREV_REPLACEMENT_HTML = `<button class="button button--primary pointer-events-auto next" type="button" is="next-button" aria-label="${ARIA_LABELS.prev}">
    <span class="btn-fill" data-fill=""></span>
    <span class="btn-text"><svg class="icon icon-chevron-right-2 icon-md transform" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg" role="presentation">
    <path d="M9.1001 5.5498L14.5601 11.0098L9.1001 16.4698" stroke="currentColor" stroke-width="0.83" stroke-miterlimit="10"></path></svg></span>
  </button>`;

  const NEXT_REPLACEMENT_HTML = `<button class="button button--primary pointer-events-auto prev" type="button" is="previous-button" aria-label="${ARIA_LABELS.next}">
    <span class="btn-fill" data-fill=""></span>
    <span class="btn-text"><svg class="icon icon-chevron-left-2 icon-md transform" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg" role="presentation">
    <path d="M12.8999 5.5498L7.4399 11.0098L12.8999 16.4698" stroke="currentColor" stroke-width="0.83" stroke-miterlimit="10"></path></svg></span>
  </button>`;

  function buildReplacementButton(html, originalButton) {
    const wrapper = document.createElement('div');
    wrapper.innerHTML = html.trim();
    const button = wrapper.firstElementChild;
    button.addEventListener('click', () => originalButton.click());
    return button;
  }

  function hideOriginalButton(button) {
    button.style.setProperty('display', 'none', 'important');
  }

  function replaceNavButtons(container) {
    if (container.dataset.jdgmNavReplaced) return;

    const prevButton = container.querySelector(PREV_SELECTOR);
    const nextButton = container.querySelector(NEXT_SELECTOR);
    if (!prevButton || !nextButton) return;

    container.dataset.jdgmNavReplaced = "true";

    hideOriginalButton(prevButton);
    hideOriginalButton(nextButton);

    container.appendChild(buildReplacementButton(NEXT_REPLACEMENT_HTML, nextButton));
    container.appendChild(buildReplacementButton(PREV_REPLACEMENT_HTML, prevButton));
  }

  document.querySelectorAll(NAV_CONTAINER_SELECTOR).forEach(replaceNavButtons);

  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (node.nodeType !== Node.ELEMENT_NODE) continue;

        if (node.matches(NAV_CONTAINER_SELECTOR)) {
          replaceNavButtons(node);
        }
        node.querySelectorAll(NAV_CONTAINER_SELECTOR).forEach(replaceNavButtons);
      }
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
});

document.addEventListener("DOMContentLoaded", () => {
  "use strict";

  // judge.me のトップページ「カードカルーセル」が出力する評価テキストは、
  // スコア・星・件数がフラットに並んでいて CSS で個別装飾できない。
  //   <span class="jdgm-rating-text">4.00 <span class="jdgm-rating-star">★</span> (<span class="jdgm-reviews-count">7</span>)</span>
  // これを以下の構造へ組み替える（星は削除、件数に「 Reviews」を付与）。
  //   <span class="jdgm-rating-text"><span class="score">4.00</span> <span class="count">(<span class="jdgm-reviews-count">7 Reviews</span>)</span></span>
  //
  // judge.me はキャッシュが無い初回遷移時、骨組みを挿入したあと非同期で
  // 集計データを .jdgm-reviews-count へセレクタ経由で上書きする（2 段階描画）。
  // そのため変換は「望ましい形になっていなければ組み立て直す」冪等処理にし、
  // カルーセルの characterData も監視して段階 2 の上書き後に再適用する。

  const CAROUSEL_SELECTOR = '.jdgm-cards-carousel';
  const RATING_TEXT_SELECTOR = '.jdgm-cards-carousel .jdgm-rating-text';
  const REVIEWS_LABEL = ' Reviews';

  function isCanonical(el) {
    const children = el.children;
    if (children.length !== 2) return false;
    if (!children[0].classList.contains('score')) return false;
    if (!children[1].classList.contains('count')) return false;

    const countEl = el.querySelector('.count .jdgm-reviews-count');
    if (!countEl) return false;

    const text = countEl.textContent.trim();
    return /^\d/.test(text) && text.endsWith(REVIEWS_LABEL.trim());
  }

  function transformRatingText(el) {
    // 既に望ましい形なら DOM を書き換えない（= 自分の書き込みによる
    // MutationObserver の再発火をここで収束させる）。
    if (isCanonical(el)) return;

    // スコア：既存の .score があればそれを、無ければ星を除いたテキストから拾う。
    const existingScore = el.querySelector('.score');
    const scoreSource = existingScore ? existingScore.textContent : el.textContent;
    const scoreMatch = scoreSource.match(/[\d.]+/);

    // 件数：既に「 Reviews」が付いていても数字部分だけを取り出す。
    const countEl = el.querySelector('.jdgm-reviews-count');
    const countMatch = countEl ? countEl.textContent.match(/\d[\d,]*/) : null;

    // judge.me の段階 1 では数値が未確定のことがある。取れないうちは何もせず、
    // 次の mutation（段階 2 の上書き）を待つ。
    if (!scoreMatch || !countMatch) return;

    const scoreSpan = document.createElement('span');
    scoreSpan.className = 'score';
    scoreSpan.textContent = scoreMatch[0];

    const reviewsCount = document.createElement('span');
    reviewsCount.className = 'jdgm-reviews-count';
    reviewsCount.textContent = `${countMatch[0]}${REVIEWS_LABEL}`;

    const countSpan = document.createElement('span');
    countSpan.className = 'count';
    countSpan.appendChild(document.createTextNode('('));
    countSpan.appendChild(reviewsCount);
    countSpan.appendChild(document.createTextNode(')'));

    el.replaceChildren(scoreSpan, document.createTextNode(' '), countSpan);
  }

  function applyRatingText(root) {
    const scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll(RATING_TEXT_SELECTOR).forEach(transformRatingText);
    if (scope !== document && scope.matches && scope.matches(RATING_TEXT_SELECTOR)) {
      transformRatingText(scope);
    }
  }

  // カルーセルごとに characterData 込みで監視し、judge.me の段階 2 の
  // 上書き（子ノード差し替え・テキスト変更）後に再変換する。
  function observeCarousel(carousel) {
    if (carousel.dataset.jdgmRatingTextObserved) return;
    carousel.dataset.jdgmRatingTextObserved = 'true';

    carousel.querySelectorAll('.jdgm-rating-text').forEach(transformRatingText);

    const observer = new MutationObserver(() => {
      carousel.querySelectorAll('.jdgm-rating-text').forEach(transformRatingText);
    });
    observer.observe(carousel, { childList: true, subtree: true, characterData: true });
  }

  function scanCarousels(root) {
    const scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll(CAROUSEL_SELECTOR).forEach(observeCarousel);
    if (scope !== document && scope.matches && scope.matches(CAROUSEL_SELECTOR)) {
      observeCarousel(scope);
    }
  }

  applyRatingText(document);
  scanCarousels(document);

  const ratingTextObserver = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (node.nodeType !== Node.ELEMENT_NODE) continue;
        applyRatingText(node);
        scanCarousels(node);
      }
    }
  });

  ratingTextObserver.observe(document.body, { childList: true, subtree: true });
});

document.addEventListener("DOMContentLoaded", () => {
  "use strict";

  // judge.me のトップページ「カードカルーセル」とレビュー画像モーダルの
  // 前後ボタンを、テーマのボタンデザイン（.button / .btn-fill / .btn-text）に合わせる。
  // button 要素は置き換えず、class の追加と innerHTML の差し替えのみ行うことで、
  // カルーセルの onclick 属性とモーダルの Vue クリックリスナーを保持する。

  const CHEVRON = {
    left: '<svg class="icon icon-chevron-left-2 icon-md transform" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg" role="presentation">\n<path d="M12.8999 5.5498L7.4399 11.0098L12.8999 16.4698" stroke="currentColor" stroke-width="0.83" stroke-miterlimit="10"></path></svg>',
    right: '<svg class="icon icon-chevron-right-2 icon-md transform" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg" role="presentation">\n<path d="M9.1001 5.5498L14.5601 11.0098L9.1001 16.4698" stroke="currentColor" stroke-width="0.83" stroke-miterlimit="10"></path></svg>',
  };

  const BUTTON_CONFIGS = [
    {
      selector: '.jdgm-cards-carousel .jdgm-arrow[aria-label="Previous slide"]',
      classes: ['button', 'button--secondary', 'pointer-events-auto'],
      direction: 'left',
    },
    {
      selector: '.jdgm-cards-carousel .jdgm-arrow[aria-label="Next slide"]',
      classes: ['button', 'button--secondary', 'pointer-events-auto'],
      direction: 'right',
    },
    {
      selector: '.jm-navigation__previous',
      classes: ['button', 'button--primary', 'pointer-events-auto'],
      direction: 'left',
    },
    {
      selector: '.jm-navigation__next',
      classes: ['button', 'button--primary', 'pointer-events-auto'],
      direction: 'right',
    },
  ];

  function styleButton(button, config) {
    // 既にテーマ用の中身へ差し替え済みならスキップ（judge.me の再描画で
    // 中身が戻された場合はガードが外れて再適用される）。
    if (button.querySelector('.btn-fill')) return;

    button.classList.add(...config.classes);
    button.innerHTML = `<span class="btn-fill" data-fill=""></span>\n<span class="btn-text">${CHEVRON[config.direction]}</span>`;

    // .btn-fill のスライド演出はテーマの JS 駆動（theme.HoverButton が mouseenter /
    // mouseleave で [data-fill] を Motion.animate する）。judge.me の素の <button> は
    // hover-button としてアップグレードされないため、ここで手動で配線する。
    // .load() は touch 端末・data-button-hover="none" のとき早期 return する。
    if (window.theme && theme.HoverButton) {
      new theme.HoverButton(button).load();
    }
  }

  function applyAll(root) {
    const scope = root && root.querySelectorAll ? root : document;
    for (const config of BUTTON_CONFIGS) {
      scope.querySelectorAll(config.selector).forEach((button) => styleButton(button, config));
      if (scope !== document && scope.matches && scope.matches(config.selector)) {
        styleButton(scope, config);
      }
    }
  }

  applyAll(document);

  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (node.nodeType !== Node.ELEMENT_NODE) continue;
        applyAll(node);
      }
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
});

document.addEventListener("DOMContentLoaded", () => {
  "use strict";

  // judge.me のレビュー関連モーダルの閉じるボタンを、テーマのボタンデザイン

  // （.button / .btn-fill / .btn-text）に合わせ、閉じるアイコンを icon-close-3 に差し替える。
  //   .jm-indicator__close            … レビュー画像インジケーター / モーダル（Vue コンポーネント）
  //   .jdgm-write-review-modal__close-btn … レビューを書くモーダル（judge.me スクリプトが click を直接バインド）
  // どちらも button 要素は置き換えず、class 追加と innerHTML 差し替えのみ行い、
  // Vue のクリックリスナーと judge.me のイベントを保持する。

  const CLOSE_ICON = '<svg class="icon icon-close-3 icon-md" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4.3999 4.2998L23.7699 23.6698" stroke="currentColor" stroke-width="0.83" stroke-miterlimit="10"></path><path d="M23.7699 4.2998L4.3999 23.6698" stroke="currentColor" stroke-width="0.83" stroke-miterlimit="10"></path></svg>';

  const COMMON_CLASSES = ['button', 'button--primary', 'flex', 'items-center', 'justify-center'];

  const BUTTON_CONFIGS = [
    {
      selector: '.jm-indicator__close',
      ariaLabel: 'Close',
    },
    {
      selector: '.jdgm-write-review-modal__close-btn',
      ariaLabel: 'Close review form',
    },
  ];

  function styleButton(button, config) {
    // 既にテーマ用の中身へ差し替え済みならスキップ（judge.me / Vue の再描画で
    // 中身が戻された場合はガードが外れて再適用される）。
    if (button.querySelector('.btn-fill')) return;

    button.classList.add(...COMMON_CLASSES);
    button.setAttribute('is', 'hover-button');
    button.setAttribute('aria-label', config.ariaLabel);
    button.innerHTML = `<span class="btn-fill" data-fill=""></span>\n<span class="btn-text">${CLOSE_ICON}</span>`;

    // 既存要素への is="hover-button" 付与ではカスタム要素アップグレードは起きないため、
    // .btn-fill のスライド演出を手動で配線する（既存のカルーセル差し替え処理と同じ）。
    // .load() は touch 端末・data-button-hover="none" のとき早期 return する。
    if (window.theme && theme.HoverButton) {
      new theme.HoverButton(button).load();
    }
  }

  function applyAll(root) {
    const scope = root && root.querySelectorAll ? root : document;
    for (const config of BUTTON_CONFIGS) {
      scope.querySelectorAll(config.selector).forEach((button) => styleButton(button, config));
      if (scope !== document && scope.matches && scope.matches(config.selector)) {
        styleButton(scope, config);
      }
    }
  }

  applyAll(document);

  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (node.nodeType !== Node.ELEMENT_NODE) continue;
        applyAll(node);
      }
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
});
